module.exports = __webpack_public_path__ + "img/bobiho_bobocoin.gm.bde0910.png";